/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Locallogin_Signoutbutton3Inputs */

const en_locallogin_signoutbutton3 = /** @type {(inputs: Locallogin_Signoutbutton3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign out (local session)`)
};

/**
* | output |
* | --- |
* | "Sign out (local session)" |
*
* @param {Locallogin_Signoutbutton3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const locallogin_signoutbutton3 = /** @type {((inputs?: Locallogin_Signoutbutton3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locallogin_Signoutbutton3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_locallogin_signoutbutton3(inputs)
});
export { locallogin_signoutbutton3 as "localLogin_signOutButton" }